<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="12" offset-sm="0">
        <v-card id="customerlistcard" :loading="loading">
          <h2 v-if="!!!orderList">Keine Bestellungen gefunden</h2>
          <v-data-table
            :headers="headers"
            :items="items"
            :itemsPerPage="100"
            multi-sort
          >
            <template slot="item.username" slot-scope="{ item }">
              {{ item.user.firstname }} {{ item.user.lastname }}
            </template>

            <template slot="item.date" slot-scope="{ item }">
              {{ formatOrderDate(item.date) }}
            </template>

            <template slot="item.lieferkw" slot-scope="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{ lieferkw(item) }}
                  </span>
                </template>
                <span>{{ lieferkwStart(item) }} - {{ lieferkwEnd(item) }}</span>
              </v-tooltip>
            </template>
            <template slot="item.prices.totalSumBrutto" slot-scope="{ item }">
              {{ currencyFormat(item.prices.totalSumBrutto) }}
            </template>

            <template slot="item.orderMode" slot-scope="{ item }">
              {{ item.orderMode }}
            </template>

            <template slot="item.status" slot-scope="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    v-show="item.status === 'open'"
                    >mdi-lock-open</v-icon
                  >
                </template>
                <span>Bestellung begonnen aber noch nicht bestätigt.</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="green"
                    v-show="item.status === 'saved'"
                    >mdi-lock-open-check</v-icon
                  >
                </template>
                <span>Bestellung bestätigt</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="green"
                    v-show="item.status === 'closed'"
                    >mdi-lock-check</v-icon
                  >
                </template>
                <span>Bestellung geschlossen</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="red"
                    v-show="item.status === 'canceled'"
                    >mdi-lock-open-remove</v-icon
                  >
                </template>
                <span>Bestellung storniert</span>
              </v-tooltip>
            </template>

            <template slot="item.actions" slot-scope="{ item }">
              <div style="text-align: left">
                <v-icon small class="mr-2" @click="infoItem(item)"
                  >mdi-eye-outline</v-icon
                >
                <v-menu dense offset-y align="left">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon dense v-bind="attrs" v-on="on"
                      >mdi-dots-vertical</v-icon
                    >
                  </template>
                  <v-list dense>
                    <v-list-item
                      @click="editItem(item)"
                      v-if="checkAccess(userRoles.userRole.Manager)"
                    >
                      <v-list-item-icon>
                        <v-icon>mdi-pencil</v-icon> </v-list-item-icon
                      >Bearbeiten</v-list-item
                    >

                    <v-list-item
                      @click="askDeleteOrder(item)"
                      v-if="checkAccess(userRoles.userRole.Manager)"
                    >
                      <v-list-item-icon>
                        <v-icon>mdi-delete</v-icon> </v-list-item-icon
                      >Löschen</v-list-item
                    >

                    <v-list-item
                      v-show="item.status !== 'saved'"
                      @click="updateItemStatus(item, 'saved')"
                      v-if="
                        checkAccess(userRoles.userRole.Manager) ||
                          checkAccess(userRoles.userRole.CustomerAdmin)
                      "
                    >
                      <v-list-item-icon>
                        <v-icon>mdi-lock-check</v-icon> </v-list-item-icon
                      >Abschließen</v-list-item
                    >
                    <v-list-item
                      v-show="item.status !== 'canceled'"
                      @click="updateItemStatus(item, 'canceled')"
                      v-if="
                        checkAccess(userRoles.userRole.Manager) ||
                          checkAccess(userRoles.userRole.CustomerAdmin)
                      "
                    >
                      <v-list-item-icon>
                        <v-icon>mdi-lock-open-remove</v-icon> </v-list-item-icon
                      >Stornieren</v-list-item
                    >
                    <v-list-item
                      v-show="item.status !== 'open'"
                      @click="updateItemStatus(item, 'open')"
                      v-if="
                        checkAccess(userRoles.userRole.Manager) ||
                          checkAccess(userRoles.userRole.CustomerAdmin)
                      "
                    >
                      <v-list-item-icon>
                        <v-icon>mdi-lock-open</v-icon> </v-list-item-icon
                      >Öffnen</v-list-item
                    >
                  </v-list>
                </v-menu>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dlgDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Bestellung löschen?</v-card-title>
        <v-card-text>
          Soll die Bestellung wirklich gelöscht werden? Dies kann nicht rückgäng
          gemacht werden.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" outlined text @click="dlgDelete = false"
            >Abbrechen</v-btn
          >
          <v-btn dark color="red darken-1" @click="deleteOrder">
            <v-icon>mdi-delete</v-icon>Löschen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showOrderDetails" persistent max-width="900">
      <v-card :loading="detailLoading">
        <v-toolbar dark>
          <v-toolbar-title>Bestellungsdetails</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="showOrderDetails = false"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-toolbar>
        <v-card-text>
          <v-container v-if="itemOrderDetails">
            <v-row>
              <v-col cols="12"> OrderID: {{ itemOrderDetails._id }} </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="3"> Mitarbeiter: </v-col>
              <v-col cols="6" sm="3">
                {{ itemOrderDetails.user.firstname }}
                {{ itemOrderDetails.user.lastname }}
              </v-col>
              <v-col cols="6" sm="3"> Bestelldatum: </v-col>
              <v-col cols="6" sm="3">
                {{ formatOrderDate(itemOrderDetails.date) }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="3"> Mitarbeiter Email: </v-col>
              <v-col cols="6" sm="9">
                {{ itemOrderDetails.user.email }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="3"> Kunde/Firma: </v-col>
              <v-col cols="6" sm="9">
                {{ itemOrderDetails.customer.kdnr }} -
                {{ itemOrderDetails.customer.name }}
              </v-col>
            </v-row>
            <h3>Bestellungen:</h3>
            <v-container
              v-for="(day, index) in daySortedOrder(itemOrderDetails)"
              :key="index"
            >
              <v-row style="background-color: #ccc">
                <v-col> {{ day.day }} </v-col>
              </v-row>
              <v-row v-for="(meal, mealIndex) in day.meals" :key="mealIndex">
                <v-col cols="2" sm="1"> {{ meal.totalAmount }}x </v-col>
                <v-col cols="12" sm="7">
                  {{ meal.meal.gerichtnr }} - {{ meal.meal.name }}
                  <br v-show="meal.pickup" />
                  <span v-show="meal.pickup" style="color: green">
                    <v-icon color="green" v-show="meal.pickup" class="mr-3"
                      >mdi-check
                    </v-icon>
                    Abgeholt {{ formatOrderDate(meal.pickupTS) }}</span
                  >
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                  v-if="itemOrderDetails.customer.mahlzeiten"
                >
                  <span
                    v-for="(slot, slotIndex) in meal.timeSlots"
                    :key="slotIndex"
                  >
                    <v-chip dense v-show="slot">
                      {{ slot }}x
                      {{ itemOrderDetails.customer.mahlzeiten[slotIndex].von }}
                      -
                      {{ itemOrderDetails.customer.mahlzeiten[slotIndex].bis }}
                    </v-chip>
                  </span>
                </v-col>
              </v-row>
            </v-container>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            outlined
            text
            @click="showOrderDetails = false"
            >Schließen</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
import OrderService from "@/services/OrderService";
import CustomerService from "@/services/CustomerService";

export default {
  name: "OrderList",
  data: () => ({
    loading: false,
    detailLoading: false,
    dlgDelete: false,
    deleteItem: false,
    showOrderDetails: false,
    itemOrderDetails: null,

    headers: [
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "80px",
        align: "left"
      },
      { text: "Bestelldatum", width: "130px", value: "date" },
      { text: "LieferKW", width: "100px", value: "lieferkw" },
      { text: "Kdnr", width: "100px", value: "customer.kdnr" },
      { text: "Firma", value: "customer.name" },
      { text: "User", value: "username" },
      { text: "User Email", value: "user.email" },
      { text: "Bestellart", value: "orderMode", width: "110px" },
      { text: "Status", value: "status", width: "110px" },
      { text: "Brutto", value: "prices.totalSumBrutto", width: "110px" }
    ]
  }),
  components: {},
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  methods: {
    formatOrderDate(date) {
      return moment(date).format("DD.MM.YYYY HH:mm:ss");
    },
    lieferkw(item) {
      if (!item || item.days.length == 0) {
        return null;
      }
      return moment(item.days[0].dayDate).isoWeek();
    },
    lieferkwStart(item) {
      if (!item || item.days.length == 0) {
        return null;
      }
      const kw = moment(item.days[0].dayDate).isoWeek();

      return moment()
        .isoWeek(kw)
        .isoWeekday(1)
        .format("DD.MM.YYYY");
    },
    lieferkwEnd(item) {
      if (!item || item.days.length == 0) {
        return null;
      }
      const kw = moment(item.days[0].dayDate).isoWeek();

      return moment()
        .isoWeek(kw)
        .isoWeekday(7)
        .format("DD.MM.YYYY");
    },

    askDeleteOrder(item) {
      this.deleteCustomerName = item.name1;
      this.dlgDelete = true;
      this.deleteItem = item;
    },
    editItem(item) {
      this.$router.push({ name: "customer-edit", params: { id: item._id } });
    },
    updateItemStatus(item, status) {
      OrderService.updateStatus(item._id, status)
        .then(() => {
          item.status = status;
          this.$notify({
            group: "dataline",
            type: "success",
            title: "Gespeichert",
            text: "Der Status der Bestellung wurde erfolgreich gespeichert."
          });
        })
        .catch(() => {
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Fehler beim speichern",
            text: "Der Status der Bestellung konnte nicht gespeichert werden."
          });
        });
    },
    infoItem(item) {
      this.detailLoading = true;
      OrderService.fetch(item._id)
        .then(result => {
          this.itemOrderDetails = result.data.data;
          return CustomerService.get(item.customer._id);
        })
        .then(customer => {
          if (!customer.data.data) {
            this.itemOrderDetails.customer = item.customer;
          } else {
            this.itemOrderDetails.customer = customer.data.data;
          }

          this.showOrderDetails = true;
        })
        .catch(() => {
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Abfrage fehlgeschlagen",
            text: "Bestellung konnte nicht abgefragt werden."
          });
        })
        .finally(() => {
          this.detailLoading = false;
        });
    },
    deleteOrder() {
      this.dlgDelete = false;
      this.$store
        .dispatch("order/deleteOrder", this.deleteItem._id)
        .then(() => {
          this.$notify({
            group: "dataline",
            type: "info",
            title: "Bestellung gelöscht",
            text: "Bestellung wurde gelöscht"
          });
          this.deleteCustomerName = "";
        })
        .catch(() => {
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Löschen fehlgeschlagen",
            text: "Bestellung konnte nicht gelöscht werden."
          });
        });
    },
    daySortedOrder(item) {
      const order = item.days;
      let days = [];
      for (let index in order) {
        let day = days.find(el => el.day == order[index].day);
        let timeSlotIndex = Number.parseInt(order[index].timeSlot);

        if (!day) {
          day = {
            day: order[index].day,
            meals: []
          };
          days.push(day);
        }

        let mealItem = day.meals.find(
          el => el.meal.gerichtnr == [order[index].meal.gerichtnr]
        );

        if (!mealItem) {
          mealItem = {
            meal: order[index].meal,
            timeSlots: [],
            totalAmount: 0,
            pickup: order[index].pickup || null,
            pickupTS: order[index].pickupTS || null,
            check: order[index].check || null,
            checkTS: order[index].checkTS || null
          };

          day.meals.push(mealItem);
        }

        if (order[index].amount > 0) {
          mealItem.timeSlots[timeSlotIndex] = order[index].amount;
          mealItem.totalAmount += order[index].amount;
        }
      }
      const sorted = days.sort((a, b) => {
        return (
          moment(a.day, "DD.MM.YYYY").format("YYYYMMDD") -
          moment(b.day, "DD.MM.YYYY").format("YYYYMMDD")
        );
      });
      return sorted;
    },
    currencyFormat(value = 0) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
    checkAccess(role) {
      const user = this.$store.getters["user/getUser"];

      if (!user) {
        return false;
      }
      if (
        user.role === this.$store.getters["user/userRoles"].userRole.SuperUser
      ) {
        return true;
      } else if (user.role === role) {
        return true;
      } else {
        return false;
      }
    }
  },

  computed: {
    userRoles() {
      return this.$store.getters["user/userRoles"];
    },
    orderList() {
      return this.$store.getters["order/getOrders"];
    }
  },

  created() {
    moment.locale("de-de");
    this.loading = true;
    this.$store
      .dispatch("order/fetchOrders")
      .then(() => {
        this.loading = false;
      })
      .catch(error => {
        this.loading = false;
        const msg = error.response.data.error
          ? error.response.data.error
          : error.message;
        if (error.response.status != 401) {
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Fehler",
            text: msg
          });
        }
      });
  }
};
</script>

<style scoped>
#customerlistcard {
  margin: 20px;
}
</style>
